export default function Analytics() {
  return (
    <div>
      <h2 className="text-lg font-semibold text-text_primary mb-1">Analytics</h2>
      <p className="text-sm text-text_muted">Track opens, clicks, and campaign performance.</p>
    </div>
  );
}
